/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import StateDependencyComponent from '../StateManager/StateDependencyComponent';
import StateEvent from '../StateManager/StateEvent';
import { StateID } from '../StateManager/StateID';
import StateReference from '../StateManager/StateReference';

const {ccclass, property} = cc._decorator;

@ccclass
export default class Loader extends StateDependencyComponent
{
    @property({ type: StateReference, visible: true })
    private _loadOnState: StateReference = new StateReference(StateID.Initializing, true);

    @property({ visible: true})
    private _gameSceneName: string = "MoneyFrog";

    protected onLoad(): void
    {
        super.onLoad();
    }

    protected start(): void
    {
        super.start([this._loadOnState]);

        cc.game.addPersistRootNode(this.node);

        this._loadOnState.Value.StateManager.StartPlay();
    }

    protected onDestroy(): void
    {
        super.onDestroy();
    }

    protected onStateChangeHandler = (event: StateEvent): void =>
    {
        if (event.State === this._loadOnState.Value)
        {
            this.node.destroyAllChildren();
            cc.director.loadScene(this._gameSceneName);
        }
    }
}
